export const EVENTS_QUERY_KEYS = {
  all: ["events"] as const,
  allAdmin: ["events", "admin"] as const,
  byIdPublicOrSlug: (idOrSlug: string) => ["events", idOrSlug] as const,

  byIdPublicOrSlugAdmin: (idOrSlug: string) =>
    ["events", "admin", idOrSlug] as const,
  publicInfo: (idOrSlug: string) => ["events", "public", idOrSlug] as const,
  joinInfo: (
    idOrSlug: string,
    inv: string | undefined,
    lang: string | undefined,
  ) => ["events", "join-info", idOrSlug, inv ?? null, lang ?? null] as const,
} as const;
